import React from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
  InboxFilledIcon,
  DraftsFilledIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicListSelected = () => {
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Selected List Item
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"Changed primary text and icon in primary main color when selected."}
          background
          value={
            '                <List>\n' +
            "                            <ListItemButton\n" +
            "                                selected={selectedIndex === 0}\n" +
            "                                onClick={(event) => handleListItemClick(event, 0)}\n" +
            "                            >\n" +
            "                                <ListItemIcon>\n" +
            "                                    <InboxIcon />\n" +
            "                                </ListItemIcon>\n" +
            '                                <ListItemText primary="Inbox" />\n' +
            "                            </ListItemButton>\n" +
            "                            <ListItemButton\n" +
            "                                selected={selectedIndex === 1}\n" +
            "                                onClick={(event) => handleListItemClick(event, 1)}\n" +
            "                            >\n" +
            "                                <ListItemIcon>\n" +
            "                                    <DraftsIcon />\n" +
            "                                </ListItemIcon>\n" +
            '                                <ListItemText primary="Drafts" />\n' +
            "                            </ListItemButton>\n" +
            "                        </List>"
          }
        >
          <Paper p={3} elevation={0} sx={{ width: 250 }}>
            <List>
              <ListItemButton
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
              >
                <ListItemIcon>
                  <InboxFilledIcon />
                </ListItemIcon>
                <ListItemText primary="Inbox" />
              </ListItemButton>
              <ListItemButton
                selected={selectedIndex === 1}
                onClick={(event) => handleListItemClick(event, 1)}
              >
                <ListItemIcon>
                  <DraftsFilledIcon />
                </ListItemIcon>
                <ListItemText primary="Drafts" />
              </ListItemButton>
            </List>
          </Paper>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BasicListSelected;
